export default __webpack_public_path__ + "static/media/GA_Snappy-3.8b7de347.wav";